<template>
    <UiModalMobile
        title="Display settings"
        :isOpen="isOpen"
        @close="$emit('close')"
    >
        <template #content>
            <div>
                <fieldset class="flex flex-col space-y-6">
                    <legend class="text-base font-medium text-slate-800 dark:text-slate-100">
                        Group by
                    </legend>
                    <!-- Group by options-->
                    <label
                        class="flex items-center gap-2 cursor-pointer group"
                        @click="localGroupBy = null"
                    >
                        <div class="relative flex items-center">
                            <input
                                type="radio"
                                name="groupByOption"
                                value="user_name"
                                class="absolute opacity-0"
                                :checked="localGroupBy === null"
                            />
                            <span
                                :class="[
                                    localGroupBy === null
                                        ? 'bg-10x-orange'
                                        : 'bg-white dark:bg-slate-800 border border-slate-300',
                                    'w-4 h-4 rounded-lg flex items-center justify-center',
                                ]"
                            >
                                <span
                                    v-if="localGroupBy === null"
                                    class="w-1.5 h-1.5 bg-white dark:bg-slate-800 rounded-full"
                                ></span>
                            </span>
                        </div>
                        <span
                            class="text-base text-slate-800 dark:text-slate-100 group-hover:text-slate-900"
                        >
                            None selected
                        </span>
                    </label>
                    <label
                        v-for="option in groupingOptions"
                        :key="option.id"
                        class="flex items-center gap-2 cursor-pointer group"
                        @click="localGroupBy = option"
                    >
                        <div class="relative flex items-center">
                            <input
                                type="radio"
                                name="groupByOption"
                                value="user_name"
                                class="absolute opacity-0"
                                :checked="localGroupBy?.id === option.id"
                            />
                            <span
                                :class="[
                                    localGroupBy?.id === option.id
                                        ? 'bg-10x-orange'
                                        : 'bg-white dark:bg-slate-800 border border-slate-300',
                                    'w-4 h-4 rounded-lg flex items-center justify-center',
                                ]"
                            >
                                <span
                                    v-if="localGroupBy?.id === option.id"
                                    class="w-1.5 h-1.5 bg-white dark:bg-slate-800 rounded-full"
                                ></span>
                            </span>
                        </div>
                        <span
                            class="text-base text-slate-800 dark:text-slate-100 group-hover:text-slate-900"
                        >
                            {{ option.name }}
                        </span>
                    </label>
                </fieldset>
                <hr class="border-slate-200 dark:border-slate-700 my-6" />
                <transition-group name="fade">
                    <fieldset
                        v-show="localGroupBy?.id"
                        class="flex flex-col space-y-6"
                        key="fieldset"
                    >
                        <legend class="text-base font-medium text-slate-800 dark:text-slate-100">
                            Subgroup
                        </legend>
                        <!-- Subgroup by options-->
                        <label
                            class="flex items-center gap-2 cursor-pointer group"
                            @click="localSubgroupBy = null"
                        >
                            <div class="relative flex items-center">
                                <input
                                    type="radio"
                                    name="groupByOption"
                                    value="user_name"
                                    class="absolute opacity-0"
                                    :checked="localSubgroupBy === null"
                                />
                                <span
                                    :class="[
                                        localSubgroupBy === null
                                            ? 'bg-10x-orange'
                                            : 'bg-white dark:bg-slate-800 border border-slate-300',
                                        'w-4 h-4 rounded-lg flex items-center justify-center',
                                    ]"
                                >
                                    <span
                                        v-if="localSubgroupBy === null"
                                        class="w-1.5 h-1.5 bg-white dark:bg-slate-800 rounded-full"
                                    ></span>
                                </span>
                            </div>
                            <span
                                class="text-base text-slate-800 dark:text-slate-100 group-hover:text-slate-900"
                            >
                                None selected
                            </span>
                        </label>
                        <label
                            v-for="option in subGroupingOptions"
                            :key="option.id"
                            class="flex items-center gap-2 cursor-pointer group"
                            @click="localSubgroupBy = option"
                        >
                            <div class="relative flex items-center">
                                <input
                                    type="radio"
                                    name="groupByOption"
                                    value="user_name"
                                    class="absolute opacity-0"
                                    :checked="localSubgroupBy?.id === option.id"
                                />
                                <span
                                    :class="[
                                        localSubgroupBy?.id === option.id
                                            ? 'bg-10x-orange'
                                            : 'bg-white dark:bg-slate-800 border border-slate-300',
                                        'w-4 h-4 rounded-lg flex items-center justify-center',
                                    ]"
                                >
                                    <span
                                        v-if="localSubgroupBy?.id === option.id"
                                        class="w-1.5 h-1.5 bg-white dark:bg-slate-800 rounded-full"
                                    ></span>
                                </span>
                            </div>
                            <span
                                class="text-base text-slate-800 dark:text-slate-100 group-hover:text-slate-900"
                            >
                                {{ option.name }}
                            </span>
                        </label>
                    </fieldset>
                    <hr class="border-slate-200 dark:border-slate-700 my-6" />
                </transition-group>
                <fieldset
                    class="flex flex-col justify-center items-start space-y-6"
                >
                    <legend class="text-base font-medium text-slate-800 dark:text-slate-100">
                        Card display options
                    </legend>
                    <button class="btn-base btn-transparent !p-0">
                        <Switch
                            :value="localShowLastFour"
                            @input="localShowLastFour = $event"
                            label="Show card numbers"
                            class="!ml-0"
                        />
                        <span class="text-gray-700 dark:text-gray-200 text-base font-normal">
                            Show card numbers
                        </span>
                    </button>

                    <button class="btn-base btn-transparent !pl-0">
                        <Switch
                            :value="localGroupSameCards"
                            @input="localGroupSameCards = $event"
                            label="Group same cards"
                            class="!ml-0"
                        />
                        <span class="text-gray-700 dark:text-gray-200 text-base font-normal">
                            Group same cards
                        </span>
                    </button>

                    <button class="btn-base btn-transparent !p-0">
                        <Switch
                            :value="localShowHiddenCards"
                            @input="localShowHiddenCards = $event"
                            label="Show hidden cards"
                            class="!ml-0"
                        />
                        <span class="text-gray-700 dark:text-gray-200 text-base font-normal">
                            Show hidden cards
                        </span>
                    </button>
                </fieldset>
            </div>
        </template>
        <template #footer>
            <div class="px-6 py-1 pb-8 bg-white dark:bg-slate-800">
                <button
                    class="w-full px-4 py-2.5 bg-slate-900 text-white rounded shadow text-sm font-medium hover:bg-slate-800 transition-colors focus:outline-none focus:ring-2 focus:ring-slate-900 focus:ring-offset-2"
                    @click="applyDisplaySettings()"
                >
                    Apply
                </button>
            </div>
        </template>
    </UiModalMobile>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useWalletStore } from '@/store/wallet';
import UiModalMobile from '@/components/ui/modal/ui-modal-mobile.vue';
import Switch from '@/components/ui/switch/switch.vue';
import { ref, watch } from 'vue';

const props = defineProps({
    isOpen: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['close']);

const walletStore = useWalletStore();
const {
    sortBy,
    sortDirection,
    groupBy,
    groupingOptions,
    subgroupBy,
    subGroupingOptions,
    showLastFour,
    groupSameCards,
    showHiddenCards,
} = storeToRefs(walletStore);
const {
    setSortBy,
    setGroupBy,
    setSubgroupBy,
    setShowLastFour,
    setGroupSameCards,
    setShowHiddenCards,
} = walletStore;

const localSortBy = ref(null);
const localSortDirection = ref(null);
const localGroupBy = ref(null);
const localSubgroupBy = ref(null);
const localShowLastFour = ref(false);
const localGroupSameCards = ref(false);
const localShowHiddenCards = ref(false);

const initLocalDisplaySettings = () => {
    localSortBy.value = sortBy.value;
    localSortDirection.value = sortDirection.value;
    localGroupBy.value = groupBy.value;
    localSubgroupBy.value = subgroupBy.value;
    localShowLastFour.value = showLastFour.value;
    localGroupSameCards.value = groupSameCards.value;
    localShowHiddenCards.value = showHiddenCards.value;
};

watch(() => props.isOpen, (newVal) => {
    if (newVal) {
        initLocalDisplaySettings();
    }
}, { immediate: true });


const isSortChecked = (column, direction) => {
    return localSortBy.value === column && localSortDirection.value === direction;
};

const updateSortOption = (sortKey, direction) => {
    localSortBy.value = sortKey;
    localSortDirection.value = direction;
};

const isGroupChecked = (option) => {
    return localGroupBy.value?.id === option.id;
};

const applyDisplaySettings = () => {
    setSortBy(localSortDirection.value, localSortBy.value);
    setGroupBy(localGroupBy.value);
    setSubgroupBy(localSubgroupBy.value);
    setShowLastFour(localShowLastFour.value);
    setGroupSameCards(localGroupSameCards.value);
    setShowHiddenCards(localShowHiddenCards.value);
    emit('close');
};
</script>
